import * as React from "react"
import { cn } from "@/lib/utils"

export interface VCCardProps extends React.HTMLAttributes<HTMLDivElement> {
  glass?: boolean
  glow?: boolean
}

export const VCCard = React.forwardRef<HTMLDivElement, VCCardProps>(
  ({ className, glass, glow, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-xl border bg-card text-card-foreground transition-shadow",
        "shadow-[0_1px_3px_0_rgb(0_0_0/0.08),0_4px_16px_-4px_rgb(0_0_0/0.10)]",
        "dark:shadow-[0_1px_3px_0_rgb(0_0_0/0.3),0_6px_24px_-6px_rgb(0_0_0/0.4)]",
        "dark:inset-ring dark:inset-ring-white/[0.04]",
        glass && "glass-panel",
        glow && "glow-gold",
        className
      )}
      {...props}
    />
  )
)
VCCard.displayName = "VCCard"
